const {
  GET_ALL_FOURNISSEUR_REQUEST,
  GET_ALL_FOURNISSEUR_SUCCESS,
  GET_ALL_FOURNISSEUR_FAIL,
  ADD_FOURNISSEUR_REQUEST,
  ADD_FOURNISSEUR_SUCCESS,
  ADD_FOURNISSEUR_FAIL,
  UPDATE_FOURNISSEUR_REQUEST,
  UPDATE_FOURNISSEUR_SUCCESS,
  UPDATE_FOURNISSEUR_FAIL,
  DELETE_FOURNISSEUR_REQUEST,
  DELETE_FOURNISSEUR_SUCCESS,
  DELETE_FOURNISSEUR_FAIL
} = require("../../actionTypes/Paramaetrage/Fournisseur");

function getAllFournisseurs(state = { data: {} }, action) {
  switch (action.type) {
    case GET_ALL_FOURNISSEUR_REQUEST:
      return { loading: true, data: {} };
    case GET_ALL_FOURNISSEUR_SUCCESS:
      return { loading: false, data: action.payload };
    case GET_ALL_FOURNISSEUR_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function addFournisseur(state = { data: {} }, action) {
  switch (action.type) {
    case ADD_FOURNISSEUR_REQUEST:
      return { loading: true, data: {} };
    case ADD_FOURNISSEUR_SUCCESS:
      return { loading: false, data: action.payload };
    case ADD_FOURNISSEUR_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function updateFournisseur(state = { data: {} }, action) {
  switch (action.type) {
    case UPDATE_FOURNISSEUR_REQUEST:
      return { loading: true, data: {} };
    case UPDATE_FOURNISSEUR_SUCCESS:
      return { loading: false, data: action.payload };
    case UPDATE_FOURNISSEUR_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

function deleteFournisseur(state = { data: {} }, action) {
  switch (action.type) {
    case DELETE_FOURNISSEUR_REQUEST:
      return { loading: true, data: {} };
    case DELETE_FOURNISSEUR_SUCCESS:
      return { loading: false, data: action.payload };
    case DELETE_FOURNISSEUR_FAIL:
      return { loading: false, error: action.data };
    default:
      return state;
  }
}

export {
  addFournisseur,
  updateFournisseur,
  deleteFournisseur,
  getAllFournisseurs
};
